<template>
  <div>
    <v-data-table class="elevation-1" :headers="headers" :items="stores" :loading="loading" :items-per-page="50"
                  :options.sync="params.options" :server-items-length="params.total" disable-sort
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [20, 50, 100]}">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>店铺列表</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field class="search" append-icon="mdi-magnify" label="搜索"
                        single-line hide-details clearable v-model="params.filters.search" @click:append="getData"
                        @click:clear="clear" @keydown.enter="getData"></v-text-field>
          <v-btn icon>
            <v-icon>mdi-filter-menu</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.name="{ item }">
        {{ item.name }}
        <div v-if="item.parent">
          由 {{ item.parent }} 进行管理
        </div>
      </template>
      <template v-slot:item.timer="{ item }">
        <div v-if="item.newestOrderTime">
          最新订单时间: {{ item.newestOrderTime | dateFormat }}
        </div>
        <div v-if="item.pullOrderTime">
          拉取订单时间: {{ item.pullOrderTime | dateFormat }}
        </div>
        <div v-if="item.pullOrderItemTime">
          拉取订单商品时间: {{ item.pullOrderItemTime | dateFormat }}
        </div>
        <div v-if="item.syncOrderTime">
          同步订单状态时间: {{ item.syncOrderTime | dateFormat }}
        </div>
        <div v-if="item.syncProductTime">
          同步商品信息时间: {{ item.syncProductTime | dateFormat }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="openDetail(item.name)">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.disabled>
        <v-switch v-model="disabledModel"/>
      </template>
    </v-data-table>
    <store-editor :visible.sync="editDialog" :store-name="storeName"/>
  </div>
</template>

<script>
import StoreEditor from "@/page/Store/StoreEditor";
export default {
  name: "StoreManager",
  components: {StoreEditor},
  computed: {
    disabledModel: {
      get($event) {
        console.log("测试测试", $event);
        return false;
      },
      set(val, $event) {
        $event.target.value = false;
      }
    }
  },
  data() {
    return {
      loading: false,
      editDialog: false,
      filterDialog: false,
      storeName: null,
      headers: [
        {text: "店铺名称", align: "center", value: "name"},
        {text: "平台", align: "center", value: "marketCode"},
        {text: "部门", align: "center", value: "groupName"},
        {text: "Client ID", align: "center", value: "clientId"},
        {text: "操作时间", align: "right", value: "timer"},
        {text: "启用", align: "left", value: "disabled"},
        {text: "操作", align: "center", value: "actions"}
      ],
      stores: [],
      params: {
        options: {},
        filters: {
          search: null,
          marketplaces: [],
          stores: [],
          asins: [],
          skus: []
        },
        total: null
      }
    }
  },
  methods: {
    getData() {
      this.loading = true;

      this.$axios.post("/stores", this.params).then(
          response => {
            this.loading = false;
            console.log(response.data);
            this.stores = response.data.list;
            this.params.total = response.data.total;
          }
      );
    }, clear() {

    }, openDetail(storeName) {
      this.storeName = storeName || null;
      this.editDialog = true;
    }
  },
  watch: {
    "params.options": {
      deep: true,
      handler() {
        this.getData();
      }
    }
  }
}
</script>

<style scoped>

</style>